import React, { useEffect, useRef, useState } from "react";
import "../components/CaseStudies.css";
import { useTranslation } from 'react-i18next';

const images = Array.from({ length: 30 }, (_, i) => `/images/project_case_${i + 1}.jpg`);

// 首页轮播图同款SVG箭头
const ArrowLeft = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="20" fill="rgba(0,0,0,0.3)" />
    <path d="M14 8l-4 4 4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const ArrowRight = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="20" fill="rgba(0,0,0,0.3)" />
    <path d="M10 8l4 4-4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CaseStudies = () => {
  const { t } = useTranslation();
  const itemRefs = useRef([]);
  const [previewIdx, setPreviewIdx] = useState(null);

  // 触摸滑动切换
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const delta = touchEndX.current - touchStartX.current;
      if (Math.abs(delta) > 50) {
        if (delta > 0) {
          // 右滑，上一张
          setPreviewIdx(idx => (idx > 0 ? idx - 1 : images.length - 1));
        } else {
          // 左滑，下一张
          setPreviewIdx(idx => (idx < images.length - 1 ? idx + 1 : 0));
        }
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    itemRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });
    return () => {
      itemRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  // 监听Esc关闭预览和左右键切换
  useEffect(() => {
    if (previewIdx === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setPreviewIdx(null);
      if (e.key === 'ArrowLeft') setPreviewIdx(idx => (idx > 0 ? idx - 1 : images.length - 1));
      if (e.key === 'ArrowRight') setPreviewIdx(idx => (idx < images.length - 1 ? idx + 1 : 0));
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [previewIdx]);

  return (
    <div className="case-studies-container">
      <h2 className="section-title">{t('caseStudies.pageTitle')}</h2>
      <div className="masonry-gallery">
        {images.map((src, idx) => (
          <div
            className="masonry-item"
            key={idx}
            ref={el => (itemRefs.current[idx] = el)}
            onClick={() => setPreviewIdx(idx)}
            style={{ cursor: 'pointer' }}
          >
            <img src={src} alt={`案例${idx + 1}`} loading="lazy" />
          </div>
        ))}
      </div>
      {previewIdx !== null && (
        <div className="preview-overlay" onClick={() => setPreviewIdx(null)}>
          <div
            className="preview-modal"
            onClick={e => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <button className="preview-close" onClick={() => setPreviewIdx(null)}>&times;</button>
            <button
              className="preview-arrow preview-arrow-left"
              onClick={() => setPreviewIdx(idx => (idx > 0 ? idx - 1 : images.length - 1))}
              aria-label="上一张"
            ><ArrowLeft /></button>
            <img src={images[previewIdx]} alt={`放大预览${previewIdx + 1}`} />
            <button
              className="preview-arrow preview-arrow-right"
              onClick={() => setPreviewIdx(idx => (idx < images.length - 1 ? idx + 1 : 0))}
              aria-label="下一张"
            ><ArrowRight /></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseStudies; 